import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs import
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// Constants imports
import { URLConstants } from '../../../../_constants/url-constants';

// Model imports
import { ARPaymentParameterDto } from '../../_models/account-receivable/ar-payment/ar-payment-parameter-dto';
import { ARCreditApplicationParameterDto } from '../../_models/account-receivable/credit-applications/ar-credit-application-parameter-dto';
import { ARCreditApplicationsResultDto } from '../../_models/account-receivable/credit-applications/ar-credit-applications-result-dto';
import { ARInvoiceDetailParameterDto } from '../../_models/account-receivable/ar-invoice/ar-invoice-detail-parameter-dto';
import { ARAdjustmentParameterDto } from '../../_models/account-receivable/ar-adjustment/ar-adjustment-parameter-dto';
import { ARManualCreditApplicationParameterDto } from '../../_models/account-receivable/credit-applications/ar-manual-credit-application-parameter-dto';
import { ARCreditApplicationEditorResultDto } from '../../_models/account-receivable/credit-applications/ar-credit-application-editor-result-dto';
import { ARPostCreditApplicationParametersDto } from '../../_models/account-receivable/credit-applications/ar-post-credit-application-parameters-dto';

@Injectable({
    providedIn: 'root'
})
export class ARCreditApplicationService {
    constructor(private readonly httpClient: HttpClient) {}

    getARPaymentCreditApplications(param: ARPaymentParameterDto): Observable<ARCreditApplicationsResultDto[]> {
        const url = `${URLConstants.ccCBARBaseApiUrl}/creditapplication/payment${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(ARCreditApplicationsResultDto, response)));
    }

    getARInvoiceCreditApplications(param: ARInvoiceDetailParameterDto): Observable<ARCreditApplicationsResultDto[]> {
        const url = `${URLConstants.ccCBARBaseApiUrl}/creditapplication/invoice${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(ARCreditApplicationsResultDto, response)));
    }

    getARAdjustmentCreditApplications(param: ARAdjustmentParameterDto): Observable<ARCreditApplicationsResultDto[]> {
        const url = `${URLConstants.ccCBARBaseApiUrl}/creditapplication/adjustment${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response: any[]) => plainToClass(ARCreditApplicationsResultDto, response)));
    }

    unapplyCreditApplication(param: ARCreditApplicationParameterDto): Observable<any> {
        const url = `${URLConstants.ccCBARBaseApiUrl}/creditapplication/unapply`;
        return this.httpClient.put(url, classToPlain(param)).pipe(map((response: any) => response));
    }

    getARManualCreditApplicationEditor(
        param: ARManualCreditApplicationParameterDto
    ): Observable<ARCreditApplicationEditorResultDto> {
        const url = `${URLConstants.ccCBARBaseApiUrl}/creditapplication/editor${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(
                map((response: ARCreditApplicationEditorResultDto) =>
                    plainToClass(ARCreditApplicationEditorResultDto, response)
                )
            );
    }

    applyCreditApplication(param: ARPostCreditApplicationParametersDto): Observable<any> {
        const url = `${URLConstants.ccCBARBaseApiUrl}/creditapplication`;
        return this.httpClient.post(url, classToPlain(param)).pipe(map((response: any) => response));
    }
}
